import localforage from 'localforage';
import { FLOWS_DATABASE_NAME } from '../constants/localForageDBNames';

const flowsDatabase = (storeName: string) =>
  localforage.createInstance({
    name: FLOWS_DATABASE_NAME,
    storeName,
  });

const getStoreInstance = (dbName: string, storeName: string) => {
  switch (dbName) {
    case FLOWS_DATABASE_NAME:
      return flowsDatabase(storeName);
    default:
      console.error(
        'DB not found. You might have forgot to assign a database. Please add one in localForageService.ts',
      );
      break;
  }
};

export const newSession = (
  dbName: string,
  storeName: string,
  id: string,
): Promise<unknown> => {
  const lf = getStoreInstance(dbName, storeName);
  if (!lf) return Promise.reject();
  return lf.setItem(id, {});
};

export const retrieveStorageById = <T>(
  dbName: string,
  storeName: string,
  id: string,
): Promise<T | null> => {
  const lf = getStoreInstance(dbName, storeName);
  if (!lf) return Promise.reject();
  return lf.getItem(id);
};

export const patchStorage = async (
  dbName: string,
  storeName: string,
  id: string,
  payload: unknown,
): Promise<unknown> => {
  const lf = getStoreInstance(dbName, storeName);
  if (!lf) return;
  const storedData = await lf.getItem<Record<string, unknown>>(id);
  if (!storedData) return;
  const updatedData = Object.assign(storedData, payload);
  return lf.setItem(id, updatedData);
};
